import React from 'react'

export default function Home() {
  return (
  <>
  <h1>
    i am home
  </h1>
  </>
  )
}
